export type LocalStorage = typeof window.localStorage;

/**
 * wrapper for window.localStorage to make it easier replaceable in unit tests
 */
export const LocalStorageProvider = {
  provide: 'localStorage',
  // eslint-disable-next-line angular/window-service
  useFactory: () => window.localStorage,
};
